import { Container, Graphics } from 'pixi.js';
import type { Bullet, BulletOwner } from '../combat/bullet';

const COLORS: Record<BulletOwner, number> = {
  player: 0xffffff,
  enemy: 0xff5555,
};

const BULLET_HALF_W = 2;
const BULLET_HALF_H = 8;

export interface BulletRenderer {
  container: Container;
  sync(bullets: readonly Bullet[]): void;
}

function makeBulletGraphic(): Graphics {
  const g = new Graphics();
  g.rect(-BULLET_HALF_W, -BULLET_HALF_H, BULLET_HALF_W * 2, BULLET_HALF_H * 2).fill(0xffffff);
  return g;
}

export function createBulletRenderer(parent: Container): BulletRenderer {
  const container = new Container();
  container.label = 'bullets';
  parent.addChild(container);

  const sprites: Graphics[] = [];

  return {
    container,
    sync(bullets) {
      while (sprites.length < bullets.length) {
        const g = makeBulletGraphic();
        container.addChild(g);
        sprites.push(g);
      }
      while (sprites.length > bullets.length) {
        const g = sprites.pop();
        if (!g) break;
        container.removeChild(g);
        g.destroy();
      }
      for (let i = 0; i < bullets.length; i++) {
        const b = bullets[i]!;
        const g = sprites[i]!;
        g.x = b.x;
        g.y = b.y;
        g.tint = COLORS[b.owner];
      }
    },
  };
}
